import { combineReducers } from 'redux';

import auth from './auth.module'
import guidedSearch from './guidedSearch.module'
import filteredSearch from './filteredSearch.module'
import filters from './filters.module'
import content from './content.module'
import tools from './tools.module'
import ui from './ui.module'

// Follows the DUCKS method for organizing redux actions, reducers and actionTypes
// See: https://github.com/erikras/ducks-modular-redux

export default combineReducers({
  auth,
  guidedSearch,
  filteredSearch,
  filters,
  content,
  tools,
  ui
})
